import React from "react";
import classes from "./SuggestedBookCard.module.css";
import PrimaryButton from "../Buttons/PrimaryButton";
import { Add } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { addNewCartItem } from "../../modules/AddCartScreen/AddCartSlice";

function SuggestedBookCard({ book }) {
  const dispatch = useDispatch();
  return (
    <div className={classes.main}>
      <img
        className={classes.bookImage}
        src={book.frontThumbURL}
        alt="book-image"
      />
      <p className={classes.bookTitle}>{book.title}</p>
      <p className={classes.bookAuthor}>By {book.author}</p>
      <PrimaryButton
        className={classes.addToCart}
        onClick={() =>
          dispatch(
            addNewCartItem({
              ...book,
              count: 1,
              isProofReadingService: false,
              isListing: false,
            })
          )
        }
      >
        <Add /> Add to cart
      </PrimaryButton>
    </div>
  );
}

export default SuggestedBookCard;
